import type { ReactNode } from 'react'
import {
    SIDEBAR_ICON_SLOT_CLASS,
    SIDEBAR_RAIL_HIDE_CLASS,
} from '@/components/ui/sidebarExpandState'
import { cn } from '@/lib/utils'

export function SidebarNavRow({
    icon,
    children,
}: {
    icon: ReactNode
    children: ReactNode
}) {
    return (
        <>
            <span className={SIDEBAR_ICON_SLOT_CLASS}>{icon}</span>
            <span
                className={cn(
                    'relative z-10 min-w-0 flex-1 truncate pr-3 text-left',
                    SIDEBAR_RAIL_HIDE_CLASS,
                )}
            >
                {children}
            </span>
        </>
    )
}
